import React from "react";

function Thanks() {
  const bgStyle = {
    textAlign: "center",
    minHeight: "80vh",
    // marginTop: '10%',
    width: "100%",
    backgroundImage:
      "url(https://thewebman.github.io/coronapwa/images/thanks.svg)",
    backgroundColor: "#67BAFE",
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  };
  return <div style={bgStyle}></div>;
}

export default Thanks;

// <a href="https://www.freepik.com/free-photos-vectors/doctor">Doctor vector created by freepik - www.freepik.com</a>
// backgroundImage: "url(https://thedesignman.com/corona/images/thanks.svg)",
